import * as colors from '@pleo-io/telescope-tokens/dist/color';
import * as duration from '@pleo-io/telescope-tokens/dist/duration';
import * as opacity from '@pleo-io/telescope-tokens/dist/opacity';
import * as radius from '@pleo-io/telescope-tokens/dist/radius';
import * as shadow from '@pleo-io/telescope-tokens/dist/shadow';
import * as transition from '@pleo-io/telescope-tokens/dist/transition';

var getColor = function getColor(name) {
  return function (props) {
    return props.theme && props.theme.colors[name] || '';
  };
};

var getRGBColor = function getRGBColor(name) {
  return function (props) {
    return props.theme && props.theme.rgbColor[name] || '';
  };
};

var getRadius = function getRadius(name) {
  return function (props) {
    var _props$theme$radius$n, _props$theme;

    return (_props$theme$radius$n = (_props$theme = props.theme) == null ? void 0 : _props$theme.radius[name]) != null ? _props$theme$radius$n : '';
  };
};

var getShadow = function getShadow(name) {
  return function (props) {
    var _props$theme$shadow$n, _props$theme2;

    return (_props$theme$shadow$n = (_props$theme2 = props.theme) == null ? void 0 : _props$theme2.shadow[name]) != null ? _props$theme$shadow$n : '';
  };
};

var getOpacity = function getOpacity(name) {
  return function (props) {
    var _props$theme$opacity$, _props$theme3;

    return (_props$theme$opacity$ = (_props$theme3 = props.theme) == null ? void 0 : _props$theme3.opacity[name]) != null ? _props$theme$opacity$ : '';
  };
};

var getDuration = function getDuration(name) {
  return function (props) {
    var _props$theme$duration, _props$theme4;

    return (_props$theme$duration = (_props$theme4 = props.theme) == null ? void 0 : _props$theme4.duration[name]) != null ? _props$theme$duration : '';
  };
};

var getTransition = function getTransition(name) {
  return function (props) {
    var _props$theme$transiti, _props$theme5;

    return (_props$theme$transiti = (_props$theme5 = props.theme) == null ? void 0 : _props$theme5.transition[name]) != null ? _props$theme$transiti : '';
  };
}; // RGB


var rgbColor = {
  shade900rgb: '0, 0, 0',
  pink400rgb: '255, 200, 208',
  yellow700rgb: '223, 197, 56' // used for the yellow card

}; // Theme

var theme = {
  colors: colors,
  duration: duration,
  opacity: opacity,
  radius: radius,
  rgbColor: rgbColor,
  shadow: shadow,
  transition: transition,

  /**
   * Avoid index for spaces, use directly the numeric value
   * https://styled-system.com/demo#space-theming
   */
  space: [0]
};
export { getColor, getDuration, getOpacity, getRGBColor, getRadius, getShadow, getTransition, rgbColor, theme };